// @ts-nocheck
import pkg from '../../package.json';

export const config = { ...window.config, version: pkg.version };
export default config;
